module.exports = __webpack_public_path__ + "0e316c8cca44568e67c60ee0a8730e53.png";